import React, { ReactNode, useContext } from 'react';
import context from '../../hoc/context/product/context';
import { BannerLayout } from '../../hoc/components/layout/banner-layout';
import { FlowRouteProps } from '../flow/flow';
import Button from '../../hoc/components/button';
import { EventLabel } from '../../../services/ga';
import { EventType } from '../../../services/ga-enums-interfaces';
import Section from '../../hoc/components/section/section';
import { UserActionType } from '../../hoc/components/analytics';

interface IssueProps extends FlowRouteProps {
	title: string;
	children: ReactNode;
	label: string;
}

function Issue({ title, children, path, label, flow }: IssueProps) {
	const ctxt = useContext(context);
	return (
		<BannerLayout
			footer={true}
			mlrVersion={ctxt.json.pages.issue.mlrVersion}
			title={title}
			label={label || ctxt.json.pages.issue.label}>
			<Section width="max-w-4xl">
				<>
					{children}
					{ctxt.json.pages.issue.button && (
						<Button
							onClick={() => {
								flow.restart();
							}}
							analytics={{
								userActionType: UserActionType.click,
								eventType: EventType.SimpleEvent,
								eventCategory: path,
								eventLabel: EventLabel.Click,
								eventArgs: {},
							}}>
							{ctxt.json.pages.issue.button}
						</Button>
					)}
				</>
			</Section>
		</BannerLayout>
	);
}
export default Issue;
